module.exports = __webpack_public_path__ + "media/images/forms-icons/tabular-icon-26e11693b36f422913f5f8dbaa5fd376.svg";